// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"254":"css/app.6730","8039":"css/admin-app.6730"}[chunkId] + ".css";
};